var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1974_15208)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M6.22657 4.33789C6.22657 2.7403 7.26913 1.38645 8.71094 0.918922C8.36151 0.805641 7.98876 0.744141 7.60157 0.744141C5.61678 0.744141 4.00781 2.35311 4.00781 4.33789C4.00781 6.32267 5.61678 7.93164 7.60157 7.93164C7.98876 7.93164 8.36151 7.87014 8.71094 7.75686C7.26913 7.28933 6.22657 5.93548 6.22657 4.33789Z",
    fill: "#EBEBF0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.5312 16.1191C13.1861 16.1191 12.9062 15.8393 12.9062 15.4941C12.9062 13.0473 10.9156 11.0566 8.46875 11.0566H7.53125C5.08441 11.0566 3.09375 13.0473 3.09375 15.4941C3.09375 15.8393 2.81394 16.1191 2.46875 16.1191C2.12356 16.1191 1.84375 15.8393 1.84375 15.4941C1.84375 12.358 4.39516 9.80664 7.53125 9.80664H8.46875C11.6048 9.80664 14.1562 12.358 14.1562 15.4941C14.1562 15.8393 13.8764 16.1191 13.5312 16.1191Z",
    fill: "#F16D5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9375 8.55664C5.61128 8.55664 3.71875 6.66411 3.71875 4.33789C3.71875 2.01167 5.61128 0.119141 7.9375 0.119141C10.2637 0.119141 12.1562 2.01167 12.1562 4.33789C12.1562 6.66411 10.2637 8.55664 7.9375 8.55664ZM7.9375 1.36914C6.30053 1.36914 4.96875 2.70092 4.96875 4.33789C4.96875 5.97486 6.30053 7.30664 7.9375 7.30664C9.57447 7.30664 10.9062 5.97486 10.9062 4.33789C10.9062 2.70092 9.57447 1.36914 7.9375 1.36914Z",
    fill: "#303261"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1974_15208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.119141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.2408e9d180bdd0c643ba03aabf8488bb.svg";
export { ForwardRef as ReactComponent };